import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkText } from "uitk-react-text";
import {
  UitkCard,
  UitkCardMedia,
  UitkCardContent,
  UitkCardTextSegment,
  UitkCardLink,
  UitkCardImageLayout,
} from "uitk-react-cards";

import ProductDateSupportText from "./ProductDateSupportText";
import ProductPriceSupportText from "./ProductPriceSupportText";
import ProductTypeText from "./ProductTypeText";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { CityCardDestination } from "typings/microserviceModels/top-cities-flex-module";

const ImageLeftCardCityCard = (props: { city: CityCardDestination }) => {
  const { city } = props;
  const { name: cityName, link, deal } = city;
  const mainImage = city.images[0];
  const { formatText } = useLocalization();

  return (
    <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}>
      <UitkCardMedia>
        <UitkFigure ratio={UitkFigure.AspectRatio.R1_1}>
          <UitkImage src={mainImage.url} alt={mainImage.alt} placeholderImage={true} />
        </UitkFigure>
      </UitkCardMedia>

      <UitkCardContent>
        <UitkCardTextSegment>
          <UitkLayoutFlex direction="column" justifyContent="space-between" className="full-height">
            <UitkLayoutFlex direction="column">
              <UitkText className="uitk-type-heading-500">{cityName}</UitkText>
              <ProductTypeText />
            </UitkLayoutFlex>

            {deal && (
              <UitkLayoutFlex direction="column" className="uitk-type-right">
                <div
                  className="uitk-type-heading-300"
                  dangerouslySetInnerHTML={{
                    __html: formatText("topCities.productPrice", deal.priceFormatted),
                  }}
                />
                <ProductPriceSupportText />
                <ProductDateSupportText deal={deal} />
              </UitkLayoutFlex>
            )}
          </UitkLayoutFlex>
        </UitkCardTextSegment>
      </UitkCardContent>

      <UitkCardLink>
        <TrackedLink
          moduleName="topCities"
          rfrr="hotelTravelGuideLink"
          href={link}
          data-testid={`top-cities-image-left-card-${cityName}`}
        >
          {cityName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default ImageLeftCardCityCard;
